import { AdotelThemeProvider } from '@adotel/components'
import { useLayoutEffect } from 'react'

import { PanelLocale } from '../../localization/locale'
import RTL from '../RTL'

interface PanelLocaleProviderProps {
  children: JSX.Element
  locale: PanelLocale
  dark: boolean
}

/** One explicit locale for the document, shared components and JSS direction. */
export default function PanelLocaleProvider({
  children,
  locale,
  dark
}: PanelLocaleProviderProps): JSX.Element {
  useLayoutEffect(() => {
    document.documentElement.lang = locale
    document.documentElement.dir = locale === 'fa' ? 'rtl' : 'ltr'
  }, [locale])

  const content = locale === 'fa' ? <RTL>{children}</RTL> : children

  return (
    <AdotelThemeProvider locale={locale} isDarkthemeOn={dark}>
      {content}
    </AdotelThemeProvider>
  )
}
